"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterButtonLocalized = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DateFilterButton_1 = require("../DateFilterButton/DateFilterButton");
var DateFilterTextLocalized_1 = require("../DateFilterTextLocalized/DateFilterTextLocalized");
exports.DateFilterButtonLocalized = function (_a) {
    var dateFilterOption = _a.dateFilterOption, dateFormat = _a.dateFormat, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.isMobile, isMobile = _c === void 0 ? true : _c, customFilterName = _a.customFilterName, disabled = _a.disabled;
    return (react_1.default.createElement(DateFilterButton_1.DateFilterButton, { title: customFilterName || react_1.default.createElement(react_intl_1.FormattedMessage, { id: "dateFilterDropdown.title" }), isOpen: isOpen, isMobile: isMobile, disabled: disabled },
        react_1.default.createElement("span", { className: "s-button-text" },
            react_1.default.createElement(DateFilterTextLocalized_1.DateFilterTextLocalized, { filter: dateFilterOption, dateFormat: dateFormat }))));
};
//# sourceMappingURL=DateFilterButtonLocalized.js.map